export const zIndex = (value: number) => `
    z-index: ${value};
`;
